<script>
import delay from 'lodash/delay';
import clone from 'lodash/clone';

import './stylesheets/components/VsToast';

export default {
  props: ['notification'],
  data() {
    return {
      closeDelay: null
    }
  },
  created() {
    this.originalNotification = clone(this.notification);
    this.closeDelay = delay(() => this._removeNotification(this.originalNotification), 5000);
  },
  methods: {
    close() {
      this._removeNotification(this.notification);
    },
    _removeNotification(notification) {
      clearTimeout(this.closeDelay);
      this.$emit('remove-toast', notification);
    }
  }
}
</script>

<template lang='pug'>
.toast {{notification}}
  button.toast__close.vs-button--no-border.py-_5.px-_75(type='button', @click='close') X
</template>
